<template>
    <section class="stealth-processed-flow-item">
        <div class="grid-container">
            <div class="profile-label">
                Processed flow item
            </div>
        </div>
        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="processedFlowItemList"
                    align="center"
                    data-qa="processed-flow-item-table"
                >
                    <ds-table-grid-column
                        label="Id"
                        width="90"
                        data-qa="processed-id"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.id }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Queued flow item id"
                        width="170"
                        data-qa="processed-queued-flow-item-id"
                    >
                        <template slot-scope="processedFlowItem">
                            <span :title="processedFlowItem.queuedFlowItemId">
                                {{ processedFlowItem.queuedFlowItemId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Flow item id"
                        width="110"
                        data-qa="processed-flow-item-id"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.flowItemId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Type"
                        width="110"
                        data-qa="processed-type"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.flowItemType }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Flow recipient id"
                        width="130"
                        data-qa="processed-flow-recipient-id"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.flowRecipientId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Run date"
                        width="170"
                        data-qa="processed-run-date"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.runDate }}
                            </span>
                        </template>
                    </ds-table-grid-column>


                    <ds-table-grid-column
                        label="Processed date"
                        width="170"
                        data-qa="processed-date"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.processedDate }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status"
                        width="110"
                        data-qa="processed-status"
                    >
                        <template slot-scope="processedFlowItem">
                            <span :title="processedFlowItem.status">
                                {{ processedFlowItem.status }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Reaper message"
                        width="200"
                        data-qa="processed-reaper-message"
                    >
                        <template slot-scope="processedFlowItem">
                            <span class="reaper-message">
                                {{ processedFlowItem.reaperMessage }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Num retry"
                        width="90"
                        data-qa="processed-num-retry"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.numRetry }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Date created"
                        width="170"
                        data-qa="processed-date-created"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.dateCreated }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Last updated"
                        width="170"
                        data-qa="processed-last-updated"
                    >
                        <template slot-scope="processedFlowItem">
                            <span>
                                {{ processedFlowItem.lastUpdated }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
            <div v-if="!noResultsToDisplay">
                <p class="no-details-label">
                    No results to display
                </p>
            </div>
        </template>
    </section>
</template>

<script>
export default {
    props: {
        processedFlowItemList: Array,
    },

    computed: {
        noResultsToDisplay() {
            return this.processedFlowItemList?.length > 0;
        },
    },
};
</script>
<style lang="scss" scoped>
    .grid-container {
        margin: $spacing-250 0;
        display: flex;
    }

    .profile-label {
        margin: auto;
        font-size: 1.75rem;
        color: $color-text;
    }

    .table-scroller {
        overflow:auto;
        white-space: nowrap;
    }

    @media only screen and ($medium) {
        .grid-container {
            margin-top: 1.875rem;
            display: block;
        }
    }

    .stealth-processed-flow-item {
        display: grid;
    }

    .reaper-message{
        white-space: pre-line;
    }

    .no-details-label {
        color: $color-gray-darker;
        font-size: $font-size-lg;
        font-weight: 300;
        padding-top: $spacing-400;
    }
</style>
